/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { Text } from 'components';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from 'store/auth';

const A = styled.a.attrs(({ to, ...attrs }) => ({ href: to, ...attrs }))``;

const LinkWithTooltip = ({
  to: _to,
  title,
  text,
  icon: Icon,
  linkStyle,
  textProps,
  tooltipProps,
  asA,
  redirectToLogin,
}) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const LinkComponent = asA ? A : Link;
  const to = redirectToLogin && !isAuthenticated
    ? `/mi-cuenta?redirect=${encodeURIComponent(_to)}` : _to;

  return (
    <>
      <LinkComponent to={to} style={{ ...linkStyle, width: 'auto' }}>
        <Text {...textProps} style={{ fontSize: 'inherit', ...textProps }}>
          {text}
          {Icon && !title && (
            <Icon style={{ fontSize: 'inherit', color: 'inherit', marginLeft: 5 }} />
          )}
        </Text>
      </LinkComponent>
      {!!(Icon && title) && (
        <Tooltip title={title} {...tooltipProps}>
          <Text {...textProps}>
            <Icon style={{ fontSize: 'inherit', color: 'inherit', marginLeft: 5 }} />
          </Text>
        </Tooltip>
      )}
    </>
  );
};

LinkWithTooltip.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  asA: PropTypes.bool,
  icon: PropTypes.any,
  linkStyle: PropTypes.shape({}),
  textProps: PropTypes.shape({}),
  tooltipProps: PropTypes.shape({}),
  redirectToLogin: PropTypes.bool,
};

LinkWithTooltip.defaultProps = {
  icon: null,
  linkStyle: null,
  textProps: null,
  tooltipProps: null,
  title: null,
  asA: false,
  redirectToLogin: false,
};

export default LinkWithTooltip;
